import React, { createContext, useEffect, useState } from 'react';
import axios from './api/axios';
import { isWeaslEvent, languages} from './utils';
import InitCheckoutContainer from './containers/InitCheckoutContainer';
import { ThemeProvider } from '@material-ui/core/styles';
import theme from "./theme";
import { CssBaseline } from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import {checkoutComEvents} from "./events/checkoutCom.events";

export const PaymentContext = createContext('payment');
export const PaymentInfoContext = createContext(null);
export const WaitRedirectContext = createContext(null);
export const CheckoutComFramesReady = createContext(null);
export const EncryptedPubKey = createContext(null);
export const ExchangesFees = createContext(null);
export const PaymentRequest = createContext(null);
export const PaymentMode = createContext(null);
export const WalletItems = createContext(null);

function App({ messagesStack = []}) {
  const { i18n } = useTranslation();
  const currentLanguage = languages.find((language) => language.code === i18n.language);
  const [paymentInfo, setPaymentInfo] = useState(null);
  const [waitRedirect, setWaitRedirect] = useState(false);
  useEffect(() => {
    if(messagesStack.length > 0) {
        messagesStack.forEach((msg) => {
            receiveMessage(msg);
        })
    }
    window.addEventListener('message', receiveMessage, false);
  }, []);

  useEffect(() => {
      document.body.dir = currentLanguage?.dir || 'ltr'
  }, [currentLanguage]);

  const receiveMessage = (event) => {
    if (isWeaslEvent(event)) {
      const value = event.data.value;
      if (event.data.type === 'INIT_IFRAME') {
        onSetupApp(value)
      }

      switch (event.data.type) {
        case 'INIT_IFRAME':
          onSetupApp(value);
          break;
        default:
          return;
      }
    }
  };

  const onSetupApp = value => {
    axios.defaults.headers.common['X-ApiKey'] = value.paymentSettings.merchantPubKey;
    axios.defaults.headers.common['X-UserKey'] = value.paymentSettings.userKey;
    setPaymentInfo(value.paymentSettings);
    checkoutComEvents.emit('reInitialize')
  }

  useEffect(() => {
    const handleApplePayGlobalResponse = (event) => {
      if (!event.data || typeof event.data !== "object") return;
  
      const { type, payload } = event.data;
      console.log("Global Apple Pay Event Received:", type, payload);
  
      let paymentToken;
  
      try {
        paymentToken = typeof payload === "string" ? JSON.parse(payload) : payload;
      } catch (error) {
        console.error("Error parsing Apple Pay payload:", error);
        return;
      }
  
      if (type === "success-apple-pay") {
        console.log("Apple Pay Success:", paymentToken);
        window.postMessage({ type: "apple-pay-success", payload: paymentToken }, "*");
      } else if (type === "fail-apple-pay") {     
        console.error("Apple Pay Failed:", paymentToken);
        window.postMessage({ type: "apple-pay-failure", payload: paymentToken }, "*");
      }
    };
  
    window.addEventListener("message", handleApplePayGlobalResponse);
    return () => {
      window.removeEventListener("message", handleApplePayGlobalResponse);
    };
  }, []);
  
  

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <PaymentContext.Provider value={paymentInfo}>
        <WaitRedirectContext.Provider value={{ waitRedirect, setWaitRedirect: (v) => setWaitRedirect(v) }}>
          <InitCheckoutContainer />
        </WaitRedirectContext.Provider>
      </PaymentContext.Provider>
    </ThemeProvider>
  );
}

export default App;
